import { render } from "./Module.vue?vue&type=template&id=0e79f80f&ts=true"
import script from "./Module.vue?vue&type=script&lang=ts"
export * from "./Module.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__